import React from 'react';
import { Box, Typography, Button, Dialog } from '@mui/material';

const PublishDialog = ({ open, onClose, onPublish, classes, programTitle }) => {
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            classes={{ paper: classes.publishDialogPaper }}
            BackdropProps={{
                style: { backgroundColor: 'rgba(0, 0, 0, 0.4)' }
            }}
        >
            <Box className={classes.publishDialogContent}>
                <Typography className={classes.publishDialogTitle}>
                    Are you sure you want to publish your<br/>
                    <span className={classes.publishDialogHighlight}>“{programTitle || "AI Ethics for 5th Graders"}”</span> program?
                </Typography>
                <Typography className={classes.publishDialogSubtitle}>
                    Once published, you cannot edit it anymore.
                </Typography>
                <Box className={classes.publishDialogActions}>
                    <Button className={classes.publishDialogBtnGoBack} onClick={onClose}>
                        Go Back
                    </Button>
                    <Button className={classes.publishDialogBtnPublish} onClick={onPublish}>
                        Publish
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
};

export default PublishDialog;
